module.exports = __webpack_public_path__ + "57b760391ac03bd10f085cdbaa3c75f2.png";